
import React, { Component } from 'react';
import { connect } from 'react-redux';
import assign from 'lodash/assign';
import get from 'lodash/get';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import URI from 'urijs';

import { sagas as sagasMap } from '../../map';
import { sagas as sagasMultiScene } from '../../multiscene';
import appGetActions from '../../app/saga';
import { MultiScene, componentDidUpdateInitViewFromUrl } from '../../multiscene';
import TabPanelsViewer from './TabPanelsViewer';
import getAppModules from './getAppModules';

/**
 * Viewer containing 3D scene window for sphere photo and panel with tools.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} appLayoutProps - properties for customize layout
 * @reactProps {Object} map - actual map state
 */
class SpherePhotoViewer extends Component {

    classNames = mergeStyleSets({
        multiScene: {
        },
        divider: {
            borderLeft: '1px solid #cccccc'
        }
    });

    constructor(props) {
        super(props);
        this._multiSceneComponent = null;
    }

    componentDidUpdate(prevProps) {
        componentDidUpdateInitViewFromUrl(
            this._multiSceneComponent, this.props, prevProps
        );
    }

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    getLayout() {
        let layout = get(this.props, 'projectDefinition.app.layout', null);
        if (!layout) {
            layout = get(this.props, 'layout', {});
        }
        assign(layout, this.props.appLayoutProps);
        return layout;
    }

    getLayoutValue(name, defaultValue) {
        let layout = this.getLayout();
        return get(layout, name, defaultValue);
    }

    getLayoutValues() {
        return {
            layersPanelPosition: this.getLayoutValue('layersPanelPosition', 'left'),
            tabPanelsWidth: this.getLayoutValue('tabPanelsWidth', null)
        }
    }

    getProjectUrl() {
        let uri = new URI(this.props.projectDefinition.multiSceneProject.url);
        uri.setSearch('process', 'removePointCloud');
        return uri.toString();
    }

    render() {
        return (
            <Stack horizontal styles={{root: {height: '100%'}}} tokens={{childrenGap: 0, padding: 5}}>
                {this.renderContent(this.getLayoutValues())}
            </Stack>
        );
}

    renderContent(layoutValues) {
        let tabPanelsComponent = this.renderTabPanels(layoutValues);
        let multiScene = this.renderMultiScene(layoutValues);
        let leftComponent = tabPanelsComponent;
        let rightComponent = multiScene;
        if (layoutValues['layersPanelPosition'] === 'right') {
            leftComponent = multiScene;
            rightComponent = tabPanelsComponent;
        }
        return (
            <React.Fragment>
                {leftComponent}
                <Stack.Item className={this.classNames.divider}>
                    <div></div>
                </Stack.Item>
                {rightComponent}
            </React.Fragment>
        );
    }

    renderTabPanels(layoutValues) {
        return (
            <Stack.Item>
                <TabPanelsViewer
                    uiValues={this.props.uiValues}
                    map={this.props.map}
                    layoutValues={layoutValues}
                    onlyOverLayers={true}
                    availablePanels={['data','layer', 'print', 'user']}
                    appModules={this.getAppModules()}
                    appActions={this.props.appActions}
                    appConfig={this.props.projectDefinition.app}
                    mapActions={this.props.mapActions}
                />
            </Stack.Item>
        );
    }

    renderMultiScene(layoutValues) {
        return (
            <Stack.Item grow={1} className={this.classNames.multiScene}>
                <MultiScene
                    ref={element => this._multiSceneComponent = element}
                    projectUrl={this.getProjectUrl()}
                    initialized={this.props.multiScene.initialized}
                    mode="pano"
                    initialMode="pano"
                    modes={['pano']}
                    disableMeasure={true}
                    commands={this.props.multiScene.commands}
                    layers={this.props.map.layers}
                    multiSceneActions={this.props.multiSceneActions}
                    showHomeScene={true}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: sagasMap.getActions(dispatch),
        multiSceneActions: sagasMultiScene.getActions(dispatch),
        appActions: appGetActions(dispatch)
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        uiValues: state.app.uiValues,
        urlParams: state.app.urlParams,
        multiScene: state.multiScene.multiScene
    };
}

const ConnectedSpherePhotoViewer = connect(mapStateToProps, mapDispatchToProps)(SpherePhotoViewer);

export default ConnectedSpherePhotoViewer;
